import ASectionDivider from './index.vue';

ASectionDivider.install = app => {
  app.component(ASectionDivider.name, ASectionDivider);
};

export default ASectionDivider;
